import { useMount } from 'react-use';
import { useHistory, useLocation, useRouteMatch } from '@app/router';
import { useCustomer } from '@app/user';
import { GTM, useGATrackEvent } from '@app/analytics';
import trackEvent from '@app/segment/utils/trackEvent';
import EVENTS from '@app/segment/consts/Events';
import { DOM } from '@app/utils';

const useHandleGenericQueryParams = () => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const customer = useCustomer();
  const track = useGATrackEvent();
  const { path } = useRouteMatch();

  useMount(() => {
    if (!search) {
      return;
    }

    const currentUrl = `${pathname}${search}`;

    const params = new URLSearchParams(search);
    const gaEvent = params.get('gaEvent');

    // These just get cleaned up
    params.delete('isMfa');
    params.delete('forceLogin');
    params.delete('gaEvent');

    // GA Tracking
    if (gaEvent === 'Registered') {
      track(gaEvent);
      GTM.loginSignup('signup', customer);
      trackEvent(EVENTS.SIGN_UP, {});
    } else if (gaEvent === 'Logged In') {
      track(gaEvent);
      GTM.loginSignup('login', customer);
      trackEvent(EVENTS.LOGIN, {});
    }

    // Handle UTM Product campaign stuff
    const UTMProductCampaign = params.get('utm_product_campaign');
    if (UTMProductCampaign) {
      DOM.setCookie('utm_product_campaign', UTMProductCampaign);
      DOM.setCookie('stockx_conversion_product', path);
    }

    // Handle fbuy_ref_code
    const fbuy_ref_code = params.get('fbuy_ref_code');
    if (fbuy_ref_code && fbuy_ref_code !== 'undefined') {
      DOM.setCookie('fbuy_ref_code', fbuy_ref_code);
    }

    // Handle leadid
    const leadid = params.get('leadid');
    if (leadid && leadid !== 'undefined') {
      DOM.setCookie('stockx_cd_leadid', leadid);
    }

    // Remove them from the URL
    const paramsAsString = params.toString();
    const newUrl = paramsAsString ? `${pathname}?${paramsAsString}` : pathname;

    if (currentUrl !== newUrl) {
      history.replace(newUrl);
    }
  });
};

export default useHandleGenericQueryParams;
